angular.module('iqxCore')
.directive('kanbanBoardDragg', function () {
    return {
        link: function ($scope, element, attrs) {

            var dragData = ""
            $scope.$watch(attrs.kanbanBoardDragg, function (newValue) {
                dragData = newValue
            })

            element.bind('dragstart', function (event) {
                event.dataTransfer.setData("Text", JSON.stringify(dragData))
            })
        }
    }
})

angular.module('iqxCore')
.directive('kanbanBoardDrop', function () {
    return {
        link: function ($scope, element, attrs) {

            var dragOverClass = attrs.kanbanBoardDrop

            element.bind('dragover', function (event) {
                if (event.preventDefault){ event.preventDefault() }
                if (event.stopPropigation){ event.stopPropigation() }

                event.dataTransfer.dropEffect = 'move'
                element.addClass(dragOverClass)
            })

            element.bind('drop', function (event) {
                if (event.preventDefault) { event.preventDefault() }
                if (event.stopPropigation) { event.stopPropigation() }

                element.removeClass(dragOverClass)
                var droppedData = JSON.parse(event.dataTransfer.getData('Text'))
                $scope.onDrop(droppedData, element.attr('id'))
            })

            element.bind('dragleave', function (event) {
                element.removeClass(dragOverClass)
            })
        }
    }
})